<!--<div #content class="content">-->
<!--  <video #remote class="remote" autoplay></video>-->
<!--  <video #self class="self" autoplay muted width="400" height="300"></video>-->
<!--</div>-->

<div #container class="video-container"></div>
<div #self class="self"></div>
